export const paymentProviders = Object.freeze({
  swish: 1,
});

export const paymentProviderIds = Object.freeze({
  1: "Swish",
});
